export { default } from "./LandingCallToAction";
